export default __webpack_public_path__ + "static/media/Richmond.9903c995.png";